const toTitleCase = string => string.toLowerCase()
  .split(' ')
  .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
  .join(' ');

const capitalize = string => string.charAt(0).toUpperCase() + string.slice(1);

export { 
  toTitleCase, 
  capitalize
}